export class TipoAtendimentoCirast {
    id: number = -1;
    nome: string = "";
    valor: number = -1;
    quantidadeMaxima: number = 0;
}
